import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "zmdi-facebook-box",
  "use": "zmdi-facebook-box-usage",
  "viewBox": "0 0 480 480",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 480 480\" id=\"zmdi-facebook-box\"><defs><clipPath id=\"zmdi-facebook-box_a\" clipPathUnits=\"userSpaceOnUse\"><path d=\"M0 48h48V0H0v48Z\" /></clipPath><clipPath id=\"zmdi-facebook-box_b\" clipPathUnits=\"userSpaceOnUse\"><path d=\"M0 48h48V0H0v48Z\" /></clipPath></defs><path d=\"M380 120v60h-40c-11 0-20 9-20 20v40h60v60h-60v140h-60V300h-40v-60h40v-50c0-38.8 31.4-70 70-70M40 40v400h400V40H40z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol